//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import React, { useCallback, useState } from 'react'
import { string } from 'prop-types'
import { useDispatch } from 'react-redux'
import { change, Field } from 'redux-form'
import getProjectTypeOptions from './getProjectTypeOptions'
import { RadioGroup } from 'components/Form'

// A rag-tag radio group of dynamically generated
// project type options based on the user's role.

const ProjectType = ({ idRoot, sourceForm }) => {
  const dispatch = useDispatch()

  const [options] = useState(() => dispatch(getProjectTypeOptions()))

  const handleChange = useCallback((event, changeHandler) => {
    // allow the change to update in redux-form
    changeHandler(event)

    // also clear out the project name and rcn values for the form
    dispatch(change(sourceForm, 'rcn', ''))
    dispatch(change(sourceForm, 'projectName', ''))
  }, [])

  return (
    <Field
      idRoot={`${idRoot}-project-type`}
      className={'styled-radio radio-rows'}
      component={RadioGroup}
      label={'Project Type'}
      name={'projectTypeId'}
      onChangeCustom={handleChange}
      options={options} />
  )
}

ProjectType.propTypes = {
  idRoot: string.isRequired,
  sourceForm: string.isRequired,
}

export default ProjectType
